import type { ReactNode } from 'react';
import styles from './states.module.css';

export function ErrorState({
  title = 'Ocurrió un error',
  description,
  action,
}: {
  title?: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className={styles.center} role="alert">
      <div className={styles.iconError} aria-hidden="true">
        ⚠︎
      </div>
      <h2 className={styles.title}>{title}</h2>
      {description && <p className={styles.muted}>{description}</p>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
}
